<template>
  <div class="neu-card-ctn mx-auto my-auto">
    <div class="neu-card-icon mx-auto my-auto">
      <base-icon class="icon-width" v-if="src != '/static-appopensalud/img/icons/morillas-svg-icons/Logo/logo-receta.png' && src != '/static-appopensalud/img/icons/morillas-svg-icons/Logo/iso.png'" :src="src" blue fullWidth shadow :color="iconColor"></base-icon>
      <!-- <img style="width: 5.2em;height: 7.7em;" class=" vertical img-icon icon-width" v-if="src == '/static-appopensalud/img/icons/morillas-svg-icons/Logo/logo-receta.png'" src="/static-appopensalud/img/icons/morillas-svg-icons/Logo/logo-receta.png"/> -->
      <img style="width: 7.7em;height: 7.7em;" class=" vertical img-icon icon-width" v-if="src == '/static-appopensalud/img/icons/morillas-svg-icons/Logo/iso.png'" src="/static-appopensalud/img/icons/morillas-svg-icons/Logo/iso.png"/>
      <div class="subtitle-card-icon">
      <p v-if="link === null" v-html="paddedTitle"></p>
      <router-link v-if="link !== null" :to="link" tag="a">      
        <p v-html="paddedTitle"></p>
      </router-link>
    </div>
    </div>  
  </div>
</template>

<script>
import { BLUE_COLOUR } from '@/constants/colours'

export default {
  name: 'neu-card-function-icon',
  props: {
    src: {
      type: String,
      required: true
    },
    title: {
      type: String,
      required: true
    },
    link: {
      type: String,
      required: false
    },
    titleLines: Number,
    iconColor: {
      type: String,
      required: false,
      default: BLUE_COLOUR
    }
  },
  computed: {
    paddedTitle () {
      return this.titleLines ? `${this.title}${'<br>'.repeat(this.titleLines + 1)}` : this.title
    }
  }
}
</script>

<style lang="scss" scoped>

.img-icon {
        margin: auto;
        float: left;
        &.vertical {
          height: 150px;
          @include mobile {
            height: 150px;
          }
        }
        &:not(.vertical) {
          width: 100px;
          @include mobile {
            width: 150px;
          }
        }

        object-fit: cover;
      }
.neu-card-ctn {
  // @include mobile {
  //     padding-top: 3rem;
  //   }
  .neu-card-icon{
    display: flex;
    justify-content: center;
    @include mobile{
      height: 30rem;
      width: 15rem;
    }
    transition-duration: 999999999999999s;
    flex-direction: column;
    align-items: center;
    @media screen and (min-width:500px) and (max-width:1200px) {
    height: 25rem;
      }
    &:hover {
      @include desktop {
        padding: 4rem 6rem;
      }
      @include desktop-sm {
        padding: 0rem 4rem;
      }
      
      transition-duration: 9999999999999999s;
    }
    .icon-width{
      width:7rem;
        margin-block-end: 0rem;
    -webkit-margin-after: 1rem;
    @media screen and (min-width:500px) and (max-width:1200px) {
    -webkit-margin-before: 3rem;
      }
    }
    // box-shadow: $custom-shadow;
    border: $border;
    border-radius: $border-radius;

    // Neu Icon vertically centered
    span {
      display: block;
    }
  }

  .subtitle-card-icon  {
    width:14rem;
    height: 7rem;
    text-align: center;
    flex-direction: column;
    bottom:0;
    // -webkit-margin-after: 3rem;
    // @include desktop {
    //   margin-top: 0rem;
    // }
    

    p {
      color: $blue;
      font-weight: bold;
      font-size: 1.25rem;
      white-space: normal;
    }
  }
}

</style>


// WEBPACK FOOTER //
// src/components/base/ui/NeuCardFunctionsJustIcon.vue